export const colors = {
    LIGHT_GREY: '#EAEAEA'
};